"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var a_1 = __importDefault(require("./a"));
var audio_1 = __importDefault(require("./audio"));
var blockquote_1 = __importDefault(require("./blockquote"));
var button_1 = __importDefault(require("./button"));
var form_1 = __importDefault(require("./form"));
var iframe_1 = __importDefault(require("./iframe"));
var img_1 = __importDefault(require("./img"));
var input_1 = __importDefault(require("./input"));
var label_1 = __importDefault(require("./label"));
var li_1 = __importDefault(require("./li"));
var ol_1 = __importDefault(require("./ol"));
var optgroup_1 = __importDefault(require("./optgroup"));
var option_1 = __importDefault(require("./option"));
var select_1 = __importDefault(require("./select"));
var svg_1 = __importDefault(require("./svg"));
var textarea_1 = __importDefault(require("./textarea"));
var time_1 = __importDefault(require("./time"));
var video_1 = __importDefault(require("./video"));
var sanitizers = {
    a: a_1["default"],
    audio: audio_1["default"],
    blockquote: blockquote_1["default"],
    button: button_1["default"],
    form: form_1["default"],
    iframe: iframe_1["default"],
    img: img_1["default"],
    input: input_1["default"],
    label: label_1["default"],
    li: li_1["default"],
    ol: ol_1["default"],
    optgroup: optgroup_1["default"],
    option: option_1["default"],
    select: select_1["default"],
    svg: svg_1["default"],
    textarea: textarea_1["default"],
    time: time_1["default"],
    video: video_1["default"]
};
exports["default"] = sanitizers;
//# sourceMappingURL=index.js.map